import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { MainLayout, AuthLayout } from "./layouts";
import { NotFound } from "./core";
import { Login } from "./auth";
import routesService from "./service/routeService";
import EntryPoint from "./core/EntryComp";
import Analysis from "./components/analysis/Analysis";
function App() {
	return (
		<main>
			<ToastContainer autoClose={3000} hideProgressBar={true} />
			<BrowserRouter>
				<Routes>
					<Route path={routesService.getEntryPageRoute()} element={<EntryPoint />} />
					<Route path={routesService.getLoginRoute()} element={<AuthLayout component={Login} />} />
					<Route path={routesService.getHomePageRoute()} element={<MainLayout component={Analysis} />} />
					<Route path={routesService.getNotFoundRoute()} element={<MainLayout component={NotFound} />} />
					<Route path="*" element={<Navigate to={routesService.getNotFoundRoute()} />} />
				</Routes>
			</BrowserRouter>
		</main>
	);
}

export default App;
